import { makeStyles, tagClassNames, tokens } from '@fluentui/react-components'
import {
  CONTEXT_ENTRY_ICON_GAP,
  CONTEXT_ENTRY_ICON_SIZE,
  CONTEXT_ENTRY_TEXT_INSET,
  contextEntrySection,
  contextEntryText,
} from '../ContextCard/context-entry-styles'

export const useMessageSourcesStyles = makeStyles({
  separator: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: tokens.spacingHorizontalL,
    height: tokens.spacingVerticalL,
    color: tokens.colorNeutralForeground1,
    ...contextEntryText,
  },
  // Design wants a clear tag at rest that only greys on hover, unlike Fluent's filled default.
  tagPrimary: {
    // Fluent centres the label in a fixed-height tag; top padding pushes it down without resizing the tag.
    paddingTop: tokens.spacingVerticalXXS,
    backgroundColor: tokens.colorTransparentBackground,
    // Keeps the hover look while the popover is open and the pointer is over it instead.
    '&[aria-expanded="true"]': {
      backgroundColor: tokens.colorSubtleBackgroundHover,
    },
    ':hover': {
      backgroundColor: tokens.colorSubtleBackgroundHover,
    },
    ':hover:active': {
      backgroundColor: tokens.colorSubtleBackgroundPressed,
    },
  },
  popover: {
    maxWidth: '260px',
    maxHeight: 'calc(100vh - 16px)',
    overflowY: 'auto',
    borderRadius: tokens.borderRadiusXLarge,
  },
  popoverError: {
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
  },
  fileItem: {
    ...contextEntryText,
    alignItems: 'center',
    minHeight: 'auto',
    columnGap: CONTEXT_ENTRY_ICON_GAP,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalSNudge}`,
  },
  fileItemIcon: {
    width: CONTEXT_ENTRY_ICON_SIZE,
    height: CONTEXT_ENTRY_ICON_SIZE,
  },
  fileItemContent: {
    minWidth: 0,
    paddingLeft: CONTEXT_ENTRY_TEXT_INSET,
    wordBreak: 'break-word',
  },
  fileHeader: {
    display: 'flex',
    alignItems: 'center',
    columnGap: CONTEXT_ENTRY_ICON_GAP,
    margin: 0,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalSNudge}`,
    color: tokens.colorNeutralForeground1,
    ...contextEntryText,
    fontWeight: tokens.fontWeightRegular,
    wordBreak: 'break-word',
    '& svg': {
      flexShrink: 0,
    },
  },
  fileHeaderText: {
    paddingLeft: CONTEXT_ENTRY_TEXT_INSET,
  },
  // The section row reads as part of its file entry: only the tag reacts to hover/press.
  sectionItem: {
    minHeight: 'auto',
    paddingTop: 0,
    paddingBottom: tokens.spacingVerticalXS,
    backgroundColor: tokens.colorTransparentBackground,
    ':hover': {
      backgroundColor: tokens.colorTransparentBackground,
    },
    ':hover:active': {
      backgroundColor: tokens.colorTransparentBackground,
    },
    [`:hover .${tagClassNames.root}`]: {
      backgroundColor: tokens.colorNeutralBackground3Hover,
    },
    [`:hover:active .${tagClassNames.root}`]: {
      backgroundColor: tokens.colorNeutralBackground3Pressed,
    },
  },
  sectionItemContent: {
    display: 'flex',
    minWidth: 0,
    paddingLeft: 0,
  },
  sectionTag: {
    width: '100%',
    height: contextEntrySection.height,
    paddingInline: contextEntrySection.paddingInline,
    gridTemplateColumns: 'auto minmax(0, 1fr) auto',
  },
  sectionTagText: {
    ...contextEntryText,
    padding: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  // Disabled Fluent items still react to hover (cursor, colors); this one is only a message.
  errorItem: {
    pointerEvents: 'none',
    color: tokens.colorNeutralForeground3,
  },
  errorItemContent: {
    textAlign: 'center',
  },
})
